<script setup lang="ts">
import { cn } from "@soft-db/ui";

const props = defineProps<{
	class?: any;
	topMargin?: boolean;
}>();
</script>

<template>
	<div
		:class="
			cn(
				'max-w-300 relative z-0 mx-auto flex h-fit w-full flex-col gap-2 px-4 py-2 md:p-4 md:pb-24',
				{
					'mt-4 md:mt-10': props.topMargin,
				},
				props.class
			)
		"
	>
		<slot />
	</div>
</template>
